import React, { useLayoutEffect, useRef, useState } from 'react';
import Icon from '../../basic/icons';
import JsonRTE from '../../basic/jsonRTE';
import { AlertNotificationIcon } from './icons/alertNotification';
import parse from 'html-react-parser';

export const enum NotificationUserActions {
  CLOSABLE = 'CLOSABLE',
}

export const enum NotificationType {
  ALERT = 'ALERT',
  ATTENTION = 'ATTENTION',
  INFO = 'INFO',
}
// export interface INotification{
//     messageId : string;
//     messageBody : object;
//     messageType : string;
//     userActions ?: string[];
//     messageTags ?: string[];
// }
const NotificationTypeMsg = ({ type }: { type: string }) => {
  switch (type) {
    case NotificationType.ALERT:
      return <AlertNotificationIcon ariaLabel="warning" className="mr-2" />;
    case NotificationType.ATTENTION:
      return;
    case NotificationType.INFO:
      return;
    default:
      return;
  }
};

const NotificationUserActionMsg = ({
  action,
  messageId,
  closeNotification,
  dismissLabel,
  onDismiss,
}: {
  action: string[];
  messageId: string;
  closeNotification: (messageId: string) => void;
  dismissLabel?: string;
  onDismiss?: () => void;
}) => {
  if (!action || !messageId) return <></>;
  return action.map((item, index) => {
    if (item === NotificationUserActions.CLOSABLE) {
      return (
        <button
          key={index}
          onClick={() => {
            onDismiss?.();
            closeNotification(messageId);
          }}
          className="m-auto"
          aria-label={dismissLabel || 'Dismiss'}
        >
          <Icon name="close" className="text-xl" />
        </button>
      );
    }
    return <div key={index}></div>;
  });
};

export const NotificationMsg = ({
  data,
  closeNotification,
  index,
  total,
  onDismiss,
}: {
  data: any;
  closeNotification: (messageId: string) => void;
  index?: number;
  total?: number;
  onDismiss?: (info: { messageId: string; index?: number; summary: string }) => void;
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [summary, setSummary] = useState('');

  // Read the summary directly from what's rendered on screen instead of
  // re-parsing messageBody, so the announced text always matches what's shown.
  useLayoutEffect(() => {
    const text = contentRef.current?.textContent?.replace(/\s+/g, ' ').trim() || '';
    setSummary(text);
  }, [data]);

  const positionLabel = index && total ? `Notification ${index} of ${total}` : undefined;
  const ariaLabel = positionLabel ? `${positionLabel}${summary ? `, ${summary}` : ''}` : undefined;
  const dismissLabel = positionLabel ? `Dismiss ${positionLabel.toLowerCase()}` : 'Dismiss notification';

  return (
    <>
      <div
        className="flex flex-row justify-between pr-3"
        data-testid="personalMsg"
        role="group"
        tabIndex={0}
        aria-label={ariaLabel}
      >
        <div className="flex flex-row w-[80%] ml-5 mt-4 mb-4" ref={contentRef}>
          <div>
            <NotificationTypeMsg type={data.messageType} />
          </div>
          {data.messageBody.jsonRTE ? (
            parse(data.messageBody.jsonRTE)
          ) : data.messageBody.text ? (
            <p className="text-base">{data.messageBody.text}</p>
          ) : data.messageBody.csTemplate ? (
            <JsonRTE
              json={data.messageBody.csTemplate}
              className="text-xs min-w-[90%] items-center"
            />
          ) : (
            <p className="text-base">{data.messageBody.text}</p>
          )}
        </div>
        <NotificationUserActionMsg
          action={data.userActions}
          messageId={data.messageId}
          closeNotification={closeNotification}
          dismissLabel={dismissLabel}
          onDismiss={() => onDismiss?.({ messageId: data.messageId, index, summary })}
        />
      </div>
    </>
  );
};
